import * as React from "react";
import Component from "../../AbstractComponent";
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Button from '@material-ui/core/Button';
// import { LeavePromptDialog } from "../../Partials/Dialog/LeavePromptDialog";
// import { Entity } from "Casadesk/Entity/Entity";


export class StepperForNewUser extends Component {
  protected language =  !!this.props.app && !!this.props.app.settings &&  !!this.props.app.settings.user && !!this.props.app.settings.user.language && this.props.app.settings.user.language.iso;
  public state = {
    activeStep: 0,
    skipped: new Set(),
    openStepperForNewUser: false,
    hasModifiedData: false,
    openLeavePrompt: false,
    type: "",
    disableButtonDuringRequest: false,
    //company fields
    companyName: "",
    company: null,
    //person fields
    firstName: "",
    lastName: "",
    personDisplayName: "",
    person: null,
    firstNameError: false
  };

  constructor(public props) {
    super(props);

  }

  public componentWillMount() {
    this.setState({
      openStepperForNewUser: this.props.openStepperForNewUser,
      type: this.props.type
    });
	}

	public componentWillReceiveProps(nextProps) {
    this.setState({
      openStepperForNewUser: nextProps.openStepperForNewUser,
      type: nextProps.type
    });
  }

  public clearState = () => {
    this.setState({
      activeStep: 0,
      skipped: new Set(),
      openStepperForNewUser: false,
      hasModifiedData: false,
      openLeavePrompt: false,
      type: "",
      disableButtonDuringRequest: false,
      //company fields
      companyName: "",
      company: null,
      //person fields
      firstName: "",
      lastName: "",
      personDisplayName: "",
      person: null,
      firstNameError: false
    });
  }

  public onCloseStepper = () => {
    if(this.props.onCloseStepper) {
      this.props.onCloseStepper.call(this);
    }
  }


  /* Main logic for STEPPER */
  // Logic for stepper, use methods when we click button continue on step page, and we start logic.
  public handleNext = () => {
    const { activeStep } = this.state;
    const steps = this.getSteps();

    if(activeStep === steps.length - 1) { // it is last step
      this.onCloseStepper();
    } else {
      switch (activeStep) {
        case 0:
          return this.startStepFirst();
        case 1:
          return this.startStepSecond();
        case 2:
          return this.setState({
                activeStep: activeStep + 1,
              });
      }
    }
  };

  public plusOneStep = () => {
    const { activeStep } = this.state;
    this.setState({
      activeStep: activeStep + 1,
    });
  }

  // Here we save all steps name and get count of steps for showing user steps name.
  public getSteps = () => {
    return [this.trans("stepper/invitenewuser-step/first-title"),this.trans("stepper/invitenewuser-step/second-title"), this.trans("stepper/invitenewuser-step/third-title")];
  }

  //All components with content for steps we have here
  public getStepContent = (step) => {
    switch (step) {
      case 0:
        return this.stepContent(step, "");
      case 1:
        return this.stepContent(step, "");
      case 2:
        return this.stepContent(step, "");
      default:
        return this.trans("unknown-step");
    }
  }

  // Content details for diffenrent steps.
  public stepContent = (step, subtitle) => {
    return (
      <div>
        <div>
          {this.sectionTitle(subtitle)}
        </div>
        {step === 0 && this.firstStepDetails()}
        {step === 1 && this.secondStepDetails()}
        {step === 2 && this.thirdStepDetails()}
      </div>
    )
  }


  // Steppers components content
  public firstStepDetails = () => {
    return this.userStepFirst();
  }

  public secondStepDetails = () => {
    return this.userStepSecond();
  }

  public thirdStepDetails = () => {
    return this.userStepThird();
  }


  //Components
  public userStepFirst = () => {
    return (
      <div>
        <div className="info-text">
          {this.trans("stepper/invitenewuser-step/first-info")}
        </div>
        <img src={this.image.getLanguageImage("casadesk", this.language)} width="100%" height="auto" alt="icon"/>
      </div>
    );
  }

  public userStepSecond = () => {
    return (
      <div>
        <div className="info-text">
          {this.trans("stepper/invitenewuser-step/second-info")}
        </div>
        <div style={{display: "flex", justifyContent: "center"}}>
          <img src={this.image.getLanguageImage("menu", this.language)} width="auto" height="320px" alt="icon"/>
        </div>
      </div>
    );
  }


  public userStepThird = () => {
    return (
      <div>
        <div className="info-text">
          {this.trans("stepper/invitenewuser-step/third-info")}
        </div>
        <img src={this.image.getLanguageImage("search", this.language)} width="100%" height="auto" alt="icon"/>
      </div>
    );
  }

  // public onLeaveDialogOpen = () => {
  //   if(this.state.hasModifiedData) {
  //     this.setState({
  //       openLeavePrompt: true
  //     })
  //   } else {
  //     this.onCloseCoach();
  //   }

  // }



  // Reusebale title components

  public sectionTitle = (text) => {
    return(
      <div className="section-info-text">
        <div>{text}</div>
      </div>
    );
  }

  public sectionFieldTitle = (text) => {
    return(
      <div className="section-info-text">
        <h4>{text}</h4>
      </div>
    );
  }

  //Funcionality for steps
  //FIRST STEP LOGIC
  public startStepFirst = () => {
    this.plusOneStep()
  }

  //SECOND STEP LOGIC
  public startStepSecond = () => {
    this.plusOneStep();
  }

  public renderContent = () => {
    const steps = this.getSteps();
    const { activeStep } = this.state;

    return (
      <div className="stepper-wrapper invite-user">
        <div className="stepper-container">
        { activeStep !== steps.length &&
          <Stepper activeStep={activeStep}>
            {steps.map((label) => {
              const props = {};
              const labelProps = {};
              return (
                <Step key={label} {...props}>
                  <StepLabel {...labelProps}>{label}</StepLabel>
                </Step>
              );
            })}
          </Stepper>
        }
        <div>
          <div className="step-content-wrapper">
            {this.getStepContent(activeStep)}
          </div>
        </div>
      </div>
      { activeStep !== steps.length &&
        <div className="step-content-button-wrapper button-container" style={{justifyContent: "flex-end"}}>
          <Button
            variant="contained"
            color="primary"
            onClick={this.handleNext}
            disabled={this.state.disableButtonDuringRequest}
          >
          {activeStep === steps.length - 1 ? this.trans("dialog-button/close") : this.trans("coach/propertyowner-button/next")}
          </Button>
        </div>
      }
    </div>
    )
  }

  public render() {
    return (
      <div>
        <Dialog
          className={`dialog dialog-window dialog-assistant coach-newuser has-button-padding ${this.props.innerDialogClasses}`}
          open={this.state.openStepperForNewUser}
        >
          <DialogContent>
            {this.renderContent()}
          </DialogContent>
        </Dialog>
{/*
        <LeavePromptDialog
          {...this.props}
          prioritizeClosing={true}
          onClose={() => this.setState({ openLeavePrompt: false, nextPath: "" })}
          openLeavePrompt={this.state.openLeavePrompt}
          onDiscard={() => {this.setState({ openLeavePrompt: false, nextPath: "" }); this.onCloseCoach();}}
          onSave={() => { this.setState({ openLeavePrompt: false }); this.onSaveAfterCloseWindow() }}
          hideCross={true}
          leavePrompt={true}
        /> */}
      </div>
    );
  }
}
